import React from 'react';
import { SimpleForm as RASimpleForm } from 'react-admin';

const SimpleForm = ({ variant = 'outlined', ...props }) => (
	<RASimpleForm warnWhenUnsavedChanges {...props} />
);

export default SimpleForm;